import CityPageTemplate from "../city-template/CityPageTemplate";
import { hammondInConfig } from "./data";

export default function HammondInPage() {
  return <CityPageTemplate config={hammondInConfig} />;
}